import {useReactQuery} from "../use-query-wrapper";
import {EmployeeRequests, EmployeeRoles} from "../../utils/request-helpers/employees/employee-requests";

export const useEmployees = (locationId) => {
  return useReactQuery(
    ["active-employees"],
    () => EmployeeRequests.fetchActiveEmployees(locationId, {ROLES: true, ACTIVE: 1, INCLUDE_HOME: true}),
    {enabled: false}
  );
};

export const useEmployeeRoles = () => {
  return useReactQuery(["employee-roles"], EmployeeRoles.fetchAllRoles, {enabled: false});
};
